import { useQuery } from "react-query";
import { fetchRecentContent, getPageDetails } from "../../data-helpers";

const useActiveUsers = () => {
  const { isLoading: isActiveUsersLoading, data: activeUsersData } = useQuery(
    ["active-users"],
    fetchRecentContent,
    {
      retry: 0,
      select: (response) => {
        const { body } = response;
        const { results } = JSON.parse(body);
        return getPageDetails(results).slice(0, 8);
      },
    }
  );
  return { isActiveUsersLoading, activeUsersData };
};

export default useActiveUsers;
